<template>
  <div>
    <div class="checkbox-wrapper modal-register-conditions">
      <div class="checkbox">
        <input name="Cогласие на обработку персональных данных" type="checkbox" v-model="model" id="pnd-conditions"/>
        <label for="confirm-conditions">Даю свое <a target="_blank" href="https://exporteduru.servicecdn.ru/media/default/0003/49/69496ef69ee4889b23cc3a2944a05f96bba0b849.pdf">Согласие на обработку персональных данных</a></label>
      </div>
    </div>
  </div>
</template>

<script>
import vmMixin from "@/mixins/vmMixin";

export default {
  name: "RegistrationConfirmData",
  mixins: [vmMixin],
}
</script>

<style scoped>

</style>